import React from "react";
import "../css/container.css";

const Container = ({ children, className }) => {
  return (
    <div className={["container", className].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
};

export default Container;
